<div class="aca-admin aca-mail" [class.aca-mail--embedded]="embedded">
  <aca-page-header *ngIf="!embedded" icon="mail" [title]="'DMS.EMAIL_TEMPLATES.17B55D' | translate" [subtitle]="'DMS.UI.7E4602' | translate" />

  <!-- ── delivery: where mail actually leaves ──────────────────────────── -->
  <section class="aca-mail__delivery">
    <div class="aca-mail__deliveryhead">
      <span class="aca-mail__deliveryicon"><mat-icon>send</mat-icon></span>
      <span class="aca-mail__deliverytext">
        <span class="aca-mail__deliverytitle">{{ 'DMS.MAIL.DELIVERY_TITLE' | translate }}</span>
        <span class="aca-mail__deliverysub">{{ 'DMS.MAIL.DELIVERY_SUB' | translate }}</span>
      </span>
      <span class="aca-mail__deliverystate" [class.aca-mail__deliverystate--on]="mailMode !== 'mailto'">
        {{ (mailMode !== 'mailto' ? 'DMS.MAIL.STATE_DIRECT' : 'DMS.MAIL.STATE_MAILTO') | translate }}
      </span>
    </div>

    <div class="aca-mail__deliverygrid">
      <label class="aca-mail__field">
        <span class="aca-mail__label">{{ 'DMS.MAIL.MODE' | translate }}</span>
        <select class="aca-mail__input" [(ngModel)]="mailMode" (ngModelChange)="deliveryChanged()">
          <option value="mailto">{{ 'DMS.MAIL.MODE_MAILTO' | translate }}</option>
          <option value="alfresco">{{ 'DMS.MAIL.MODE_ALFRESCO' | translate }}</option>
          <option value="emailjs">{{ 'DMS.MAIL.MODE_EMAILJS' | translate }}</option>
          <option value="webhook">{{ 'DMS.MAIL.MODE_WEBHOOK' | translate }}</option>
        </select>
      </label>

      <label class="aca-mail__field" *ngIf="mailMode === 'emailjs' || mailMode === 'webhook'">
        <span class="aca-mail__label">{{ 'DMS.MAIL.FROM_NAME' | translate }}</span>
        <input class="aca-mail__input" [(ngModel)]="mailFromName" (ngModelChange)="deliveryChanged()" autocomplete="off" />
      </label>
    </div>

    <p class="aca-mail__hint" *ngIf="mailMode === 'mailto'">{{ 'DMS.MAIL.HINT_MAILTO' | translate }}</p>
    <p class="aca-mail__hint" *ngIf="mailMode === 'alfresco'">{{ 'DMS.MAIL.HINT_ALFRESCO' | translate }}</p>

    <ng-container *ngIf="mailMode === 'emailjs'">
      <div class="aca-mail__deliverygrid">
        <label class="aca-mail__field">
          <span class="aca-mail__label">Service ID</span>
          <input class="aca-mail__input" [(ngModel)]="ejServiceId" (ngModelChange)="deliveryChanged()" placeholder="service_…" autocomplete="off" />
        </label>
        <label class="aca-mail__field">
          <span class="aca-mail__label">Template ID</span>
          <input class="aca-mail__input" [(ngModel)]="ejTemplateId" (ngModelChange)="deliveryChanged()" placeholder="template_…" autocomplete="off" />
        </label>
        <label class="aca-mail__field">
          <span class="aca-mail__label">Public key</span>
          <input class="aca-mail__input" [(ngModel)]="ejPublicKey" (ngModelChange)="deliveryChanged()" autocomplete="off" />
        </label>
      </div>
      <p class="aca-mail__hint">{{ 'DMS.MAIL.HINT_EMAILJS' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="mailMode === 'webhook'">
      <div class="aca-mail__deliverygrid">
        <label class="aca-mail__field">
          <span class="aca-mail__label">{{ 'DMS.MAIL.HOOK_URL' | translate }}</span>
          <input class="aca-mail__input" [(ngModel)]="hookUrl" (ngModelChange)="deliveryChanged()" placeholder="https://…" autocomplete="off" />
        </label>
        <label class="aca-mail__field">
          <span class="aca-mail__label">{{ 'DMS.MAIL.HOOK_TOKEN' | translate }}</span>
          <input
            class="aca-mail__input"
            type="password"
            [(ngModel)]="hookToken"
            (ngModelChange)="deliveryChanged()"
            [placeholder]="hookTokenStored() ? ('DMS.MAIL.HOOK_TOKEN_STORED' | translate) : ''"
            autocomplete="new-password"
          />
        </label>
      </div>
      <p class="aca-mail__hint">{{ 'DMS.MAIL.HINT_WEBHOOK' | translate }}</p>
    </ng-container>

    <div class="aca-mail__deliveryactions">
      <button type="button" class="aca-mail__primary" (click)="saveDelivery()" [disabled]="deliverySaving() || !deliveryReady()">
        <mat-icon>save</mat-icon>{{ 'DMS.MAIL.SAVE' | translate }}
      </button>
      <button
        type="button"
        class="aca-mail__outline"
        (click)="testDelivery()"
        [disabled]="deliveryTesting() || !deliveryReady() || (mailMode !== 'mailto' && !mail.viewer().email)"
      >
        <mat-icon>{{ deliveryTesting() ? 'hourglass_top' : 'mail_outline' }}</mat-icon>
        {{ 'DMS.MAIL.TEST' | translate }}{{ mailMode !== 'mailto' ? ' · ' + testTarget() : '' }}
      </button>
      <span class="aca-mail__deliverytest" *ngIf="deliveryTestResult() === 'ok'"
        ><mat-icon>check_circle</mat-icon>{{ 'DMS.MAIL.TEST_OK' | translate }}</span
      >
      <span class="aca-mail__deliverytest aca-mail__deliverytest--fail" *ngIf="deliveryTestResult() === 'fail'"
        ><mat-icon>error_outline</mat-icon>{{ 'DMS.MAIL.TEST_FAIL' | translate }}</span
      >
      <span class="aca-mail__unsaved" *ngIf="deliveryDirty()"><mat-icon>edit</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_UNSAVED' | translate }}</span>
    </div>
  </section>

  <!-- ── the bar over both columns ──────────────────────────────────────── -->
  <div class="aca-mail__toolbar">
    <label class="aca-mail__searchfilter">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="search" [placeholder]="'DMS.EMAIL_TEMPLATES.74CB0E' | translate" autocomplete="off" />
    </label>

    <button type="button" class="aca-mail__primary" (click)="startCreate()">
      <mat-icon>add</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_NEW' | translate }}
    </button>

    <button type="button" class="aca-mail__outline" (click)="load()" [disabled]="loading()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.78A47D' | translate }}
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || saving()" />

  <!-- ── nothing written yet ────────────────────────────────────────────── -->
  <div class="aca-mail__welcome" *ngIf="!loading() && !creating() && !templates().length">
    <span class="aca-mail__welcomeicon"><mat-icon>mark_email_unread</mat-icon></span>
    <h3 class="aca-mail__welcometitle">{{ 'DMS.EMAIL_TEMPLATES.MAIL_EMPTY_TITLE' | translate }}</h3>
    <p class="aca-mail__welcometext">{{ 'DMS.EMAIL_TEMPLATES.MAIL_EMPTY_MSG' | translate }}</p>
    <div class="aca-mail__welcomeactions">
      <button type="button" class="aca-mail__primary" (click)="startExpiryTemplate()">
        <mat-icon>schedule_send</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_MAKE_DEFAULT' | translate }}
      </button>
      <button type="button" class="aca-mail__outline" (click)="startCreate()">
        <mat-icon>edit_note</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_MAKE_BLANK' | translate }}
      </button>
    </div>
  </div>

  <div class="aca-mail__body" [class.aca-mail__body--solo]="!templates().length" *ngIf="creating() || templates().length">
    <!-- ── list ─────────────────────────────────────────────────────────── -->
    <section class="aca-mail__list" *ngIf="templates().length">
      <aca-page-state
        *ngIf="!loading() && !filtered().length"
        state="empty"
        icon="mail"
        [title]="'DMS.EMAIL_TEMPLATES.7337DC' | translate"
        [message]="'DMS.UI.0E2160' | translate"
      />

      <ul class="aca-mail__items" *ngIf="filtered().length">
        <li *ngFor="let template of filtered(); trackBy: trackById">
          <button type="button" class="aca-mail__item" [class.aca-mail__item--on]="selected()?.id === template.id" (click)="select(template)">
            <span class="aca-mail__itemicon">
              <mat-icon>{{ iconOf(template) }}</mat-icon>
            </span>
            <span class="aca-mail__itemtext">
              <span class="aca-mail__itemname">{{ displayName(template) }}</span>
              <span class="aca-mail__itemmeta">{{ template.name }}</span>
            </span>
          </button>
        </li>
      </ul>
    </section>

    <!-- ── writing a new one ────────────────────────────────────────────── -->
    <section class="aca-mail__editor" *ngIf="creating(); else notCreating">
      <div class="aca-mail__editorhead">
        <span class="aca-mail__editortitle">
          <span class="aca-mail__editorname">{{ 'DMS.EMAIL_TEMPLATES.MAIL_NEW' | translate }}</span>
          <span class="aca-mail__editorsub">{{ 'DMS.EMAIL_TEMPLATES.MAIL_TAB_APP_HINT' | translate }}</span>
        </span>
        <span class="aca-mail__editoractions">
          <button type="button" class="aca-mail__outline" (click)="cancelCreate()">{{ 'DMS.UI.7D3094' | translate }}</button>
          <button type="button" class="aca-mail__primary" (click)="save()" [disabled]="!canSave()">
            <mat-icon>save</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.E3CA7C' | translate }}
          </button>
        </span>
      </div>

      <label class="aca-mail__field">
        <span class="aca-mail__label">{{ 'DMS.EMAIL_TEMPLATES.MAIL_NAME' | translate }}</span>
        <input class="aca-mail__input" [(ngModel)]="newName" [placeholder]="'DMS.UI.3078E7' | translate" autocomplete="off" />
        <span class="aca-mail__hint">{{ 'DMS.EMAIL_TEMPLATES.MAIL_NAME_HINT' | translate }}</span>
      </label>

      <ng-container *ngTemplateOutlet="composer" />
    </section>

    <ng-template #notCreating>
      <!-- ── one chosen from the list ───────────────────────────────────── -->
      <section class="aca-mail__editor" *ngIf="selected() as template; else nothingSelected">
        <div class="aca-mail__editorhead">
          <span class="aca-mail__editortitle">
            <span class="aca-mail__editorname">{{ displayName(template) }}</span>
            <span class="aca-mail__editorsub">
              {{ template.name }} · {{ 'DMS.UI.DC1FAC' | translate }} {{ (template.modifiedAt | acaDate: 'd MMM y HH:mm') || '—' }}
            </span>
          </span>
          <span class="aca-mail__editoractions">
            <span class="aca-mail__unsaved" *ngIf="dirty()"><mat-icon>edit</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_UNSAVED' | translate }}</span>
            <button type="button" class="aca-mail__danger" (click)="remove()" [disabled]="saving()">
              <mat-icon>delete_outline</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.MAIL_DELETE' | translate }}
            </button>
            <button type="button" class="aca-mail__primary" (click)="save()" [disabled]="!canSave()">
              <mat-icon>save</mat-icon>{{ 'DMS.EMAIL_TEMPLATES.E3CA7C' | translate }}
            </button>
          </span>
        </div>

        <ng-container *ngTemplateOutlet="composer" />
      </section>
    </ng-template>

    <ng-template #nothingSelected>
      <section class="aca-mail__editor aca-mail__editor--empty">
        <aca-page-state state="empty" icon="mail" [title]="'DMS.EMAIL_TEMPLATES.E02E34' | translate" [message]="'DMS.UI.39C961' | translate" />
      </section>
    </ng-template>
  </div>

  <!-- ── the plain-language writer, shared by creating and editing ───────── -->
  <ng-template #composer>
    <label class="aca-mail__field">
      <span class="aca-mail__label">{{ 'DMS.EMAIL_TEMPLATES.MAIL_SUBJECT' | translate }}</span>
      <input
        #subjectField
        class="aca-mail__input"
        [(ngModel)]="subject"
        (ngModelChange)="touched()"
        (focus)="remember('subject')"
        [placeholder]="'DMS.EMAIL_TEMPLATES.MAIL_SUBJECT_PH' | translate"
        autocomplete="off"
      />
    </label>

    <div class="aca-mail__field">
      <span class="aca-mail__label">{{ 'DMS.EMAIL_TEMPLATES.MAIL_INSERT' | translate }}</span>
      <div class="aca-mail__chips">
        <button
          type="button"
          class="aca-mail__chip"
          *ngFor="let placeholder of placeholders"
          [class.aca-mail__chip--on]="usesPlaceholder(placeholder)"
          [matTooltip]="placeholder.token"
          (mousedown)="$event.preventDefault()"
          (click)="insert(placeholder)"
        >
          <mat-icon>{{ placeholder.icon }}</mat-icon
          >{{ placeholder.label | translate }}
        </button>
      </div>
      <span class="aca-mail__hint">{{ 'DMS.EMAIL_TEMPLATES.MAIL_INSERT_HINT' | translate }}</span>
    </div>

    <div class="aca-mail__panes">
      <div class="aca-mail__pane">
        <div class="aca-mail__panehead">
          <span class="aca-mail__panetitle">{{ 'DMS.EMAIL_TEMPLATES.MAIL_BODY' | translate }}</span>
        </div>
        <textarea
          #bodyField
          class="aca-mail__write"
          [(ngModel)]="body"
          (ngModelChange)="touched()"
          (focus)="remember('body')"
          [placeholder]="'DMS.EMAIL_TEMPLATES.MAIL_BODY_PH' | translate"
          [attr.aria-label]="'DMS.EMAIL_TEMPLATES.MAIL_BODY' | translate"
        ></textarea>
      </div>

      <div class="aca-mail__pane">
        <div class="aca-mail__panehead">
          <span class="aca-mail__panetitle">{{ 'DMS.EMAIL_TEMPLATES.MAIL_PREVIEW' | translate }}</span>
          <span class="aca-mail__panehint">{{ 'DMS.EMAIL_TEMPLATES.MAIL_PREVIEW_HINT' | translate }}</span>
        </div>
        <div class="aca-mail__mail">
          <div class="aca-mail__mailhead">
            <span class="aca-mail__mailavatar"><mat-icon>mail</mat-icon></span>
            <span class="aca-mail__mailwho">
              <span class="aca-mail__mailfrom">{{ 'DMS.EMAIL_TEMPLATES.MAIL_FROM_VALUE' | translate }}</span>
              <span class="aca-mail__mailto"
                >{{ 'DMS.EMAIL_TEMPLATES.MAIL_TO' | translate }} {{ 'DMS.EMAIL_TEMPLATES.MAIL_TO_VALUE' | translate }}</span
              >
            </span>
          </div>
          <p class="aca-mail__mailsubject" [innerHTML]="previewSubject()"></p>
          <div class="aca-mail__mailbody" [innerHTML]="previewBody()"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
